import { describeSignInLocation, SignInLocationSource } from "../../utils/signInLocation"
import { t } from "../../i18n"

export default function SignInLocationCell({ source }: { source: SignInLocationSource | null | undefined }) {
  const view = describeSignInLocation(source)
  if (view.kind === "point") {
    return (
      <span className="font-source">
        {view.label}{" "}
        <a href={view.mapsUrl} target="_blank" rel="noopener noreferrer" className="text-primary underline">
          {t("signInLocation.openMap")}
        </a>
      </span>
    )
  }
  return (
    <span className={`font-source ${view.status === "missing" ? "text-gray-500" : "text-amber-700"}`}>
      {view.label}
    </span>
  )
}
